var _global = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};
_global.SENTRY_RELEASE = {
  id: "0ca5fa4cdbc42df40ab8502877014048fc6c7358"
};
_global.SENTRY_RELEASES = _global.SENTRY_RELEASES || {};
_global.SENTRY_RELEASES["portfolio@copacetic"] = {
  id: "0ca5fa4cdbc42df40ab8502877014048fc6c7358"
};